$( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('body.loaded').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);
  
    function runMyFunction2(){
     console.log("Customer Email Laoding");
  $('body').removeClass('loaded');
    }


    $("#minicart-wrapper, #main-scrollbar").removeAttr("tabindex");
    

  });

  $(document).ready(function(){


    $(".g-recaptcha-response").attr("aria-label", "re captcha");
    // $("#minicart").attr("aria-hidden", "true");
    $(".Banner.slider").attr("aria-label", "home page banner");
    // $(".accessibilitystmnt h3").attr("aria-level", "2");
    $("br").attr("aria-hidden", "true");
    $(".fclmn a[href='/pages/accessibility-statement']").attr("id", "accessibi");
    $(".blisttext a[href='mailto:info@ceremonycoffee.com?subject=website%20cold%20brew%20request']").attr("aria-label", "email us at, info@ceremonycoffee.com, this link will open in a new tab").attr("target", "_blank");
    $(".getintouch a[href='mailto:info@ceremonycoffee.com?ref=shown']").attr("aria-label", "email us at, info@ceremonycoffee.com, this link will open in a new tab").attr("target", "_blank");
    $(".blisttext a[href='tel:410-626-0011 ']").attr("aria-label", "call us, 410-626-0011, this link will open in a new tab").attr("target", "_blank");
    $(".getintouch a[href='tel:(410) 626-0011']").attr("aria-label", "call us, 410-626-0011, this link will open in a new tab").attr("target", "_blank");
    $("a[href='mailto:info@ceremonycoffee.com?ref=shown']").attr("aria-label", "email us, info@ceremonycoffee.com, this link will open in a new tab").attr("target", "_blank");


    $(".typebtn").click(function(){
      $(this).parent().children(".options").toggleClass('usm');
      $(this).attr('aria-expanded', function(i, attr) {
        return attr == 'true' ? 'false' : 'true'
      });
    });


    $(".mmenucnt").hide();
    $(".menu-toggle").click(function(){

      $(this).toggleClass('active');
      
      if ($(this).parent().children().children(".mmenucnt").is(':visible')){
        $(this).parent().children().children(".mmenucnt").slideUp();
    } else {
        $(".mmenucnt").slideUp();
        $(this).parent().children().children(".mmenucnt").slideDown();
    }
    $(this).attr('aria-expanded', function(i, attr) {
        return attr == 'true' ? 'false' : 'true';
    });

    });



   

    $(".moinnersubmenu").hide();
$(".mobileinnerdrop").click(function() {
    var $dropdownClicked = $(this);
    var $submenuClicked = $dropdownClicked.parent().children(".moinnersubmenu");
    
    // Remove 'active' class and aria-expanded attribute from other dropdowns
    $(".mobileinnerdrop.active").not($dropdownClicked).removeClass('active').attr('aria-expanded', 'false');
    $(".moinnersubmenu").not($submenuClicked).slideUp();
    
    // Toggle the current dropdown
    $dropdownClicked.toggleClass('active');
    
    if ($submenuClicked.is(':visible')) {
        $submenuClicked.slideUp();
        $dropdownClicked.attr('aria-expanded', 'false');
    } else {
        $submenuClicked.slideDown();
        $dropdownClicked.attr('aria-expanded', 'true');
    }
});




    $(".moinnersubmenu2").hide();
$(".mobileinnerdrop2").click(function() {
    var $currentDropdown = $(this);
    var $currentSubMenu = $currentDropdown.parent().children(".moinnersubmenu2");
    
    // Remove 'active' class and aria-expanded attribute from other dropdowns
    $(".mobileinnerdrop2.active").not($currentDropdown).removeClass('active').attr('aria-expanded', 'false');
    $(".moinnersubmenu2").not($currentSubMenu).slideUp();
    
    // Toggle the current dropdown
    $currentDropdown.toggleClass('active');
    
    if ($currentSubMenu.is(':visible')) {
        $currentSubMenu.slideUp();
        $currentDropdown.attr('aria-expanded', 'false');
    } else {
        $currentSubMenu.slideDown();
        $currentDropdown.attr('aria-expanded', 'true');
    }
});


  
  });


  $(document).ready(function() {
  $(".splide__pagination li:nth-child(1) button").append("<img src='https://cdn.shopify.com/s/files/1/2220/0129/t/13/assets/logo3.png?v=1717500959' alt='sprudge'>");
  $(".splide__pagination li:nth-child(2) button").append("<img src='https://cdn.shopify.com/s/files/1/2220/0129/t/13/assets/logo1.png?v=1717500950' alt='Food and Wine'>");
  $(".splide__pagination li:nth-child(3) button").append("<img src='https://cdn.shopify.com/s/files/1/2220/0129/t/13/assets/logo4.png?v=1717500968' alt='thrillist'>");
  $(".splide__pagination li:nth-child(4) button").append("<img src='https://cdn.shopify.com/s/files/1/2220/0129/t/13/assets/logo2.png?v=1717500955' alt='Gear petrol'>");

  $(".splide__pagination li:nth-child(1) button").attr("aria-label", "sprudge, Go to slide 1");
  $(".splide__pagination li:nth-child(2) button").attr("aria-label", "Food and Wine, Go to slide 2");
  $(".splide__pagination li:nth-child(3) button").attr("aria-label", "thrillist, Go to slide 3");
  $(".splide__pagination li:nth-child(4) button").attr("aria-label", "Gear petrol, Go to slide 3");

  
  
  $(".rc_container .subscrib").attr("role", "button");
  // $(".rc_container .subscrib").attr("aria-label", "Subscribe (10%): $81.90");

    $("#pdp-details #pdp-details-info").attr("aria-hidden", "true");


    $('.introdiv').find('h1 , h2').each(function() {
      const $this = $(this);
      if ($this.html().replace(/\s|&nbsp;/g, '').length === 0)
          $this.remove();
  });

});



$(document).ready(function() {

  $(".banner-slider .slcon-0 a.hvrbtn").attr("aria-label", "Download Now, App Ordering Made Easy, this link will open in a new tab");
  $(".filter .options").removeAttr("tabindex");

  $("p").removeAttr("aria-label");

  $("a").removeAttr("title");
  $("a[href='mailto:catering@ceremonycoffee.com']").attr("aria-label", "email us, catering@ceremonycoffee.com, this link will open in a new tab").attr("target", "_blank");
  $("a[href='tel:410-626-0011 x 111']").attr("aria-label", "call us, 410-626-0011 x 111, this link will open in a new tab").attr("target", "_blank");

  $(".slidermaintesti .splide__pagination__page").removeAttr("role");
  $(".splide__pagination").removeAttr("role");

  function updateAriaExpanded() {
      $('.slidermaintesti .splide__pagination__page, .slidermaintesti .splide__arrows').each(function() {
          if ($(this).hasClass('is-active')) {
              $(this).attr('aria-expanded', 'true');
          } else {
              $(this).attr('aria-expanded', 'false');
          }
      });
  }

  // Initial update on page load
  updateAriaExpanded();

  // Update on click
  $('.slidermaintesti .splide__pagination__page, .slidermaintesti .splide__arrows').click(function() {
      $(this).siblings().removeClass('is-active');
      $(this).addClass('is-active');
      updateAriaExpanded();
  });
});




  $(document).ready(function () {

    $('a').each(function () {
        // Check if the link is from 'casakids.com'
        if (this.hostname === 'www.shop.ceremonycoffee.com') {
            // Remove the target and rel attributes from the link
            $(this).removeAttr('target').removeAttr('rel').removeAttr('title');
        } else if (this.hostname === 'shop.ceremonycoffee.com') {
          // Remove the target and rel attributes from the link
          $(this).removeAttr('target').removeAttr('rel').removeAttr('title');
        } else if (this.hostname && this.hostname !== window.location.hostname) {
          // Create a span element with warning text
          var warningSpan = $('<span class="visuallyhidden"> This link will open in a new tab.</span>');
          // Set attributes for accessibility
          $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
          // Append the warning span inside the link
          $(this).append(warningSpan);
          $(this).removeAttr('title');
      }
    });
  });



 
  $(document).ready(function() {
    var backToTopButton = $('#back-to-top');
    
    $(window).scroll(function() {
        if ($(this).scrollTop() > 300) {
            backToTopButton.show();
        } else {
            backToTopButton.hide();
        }
    });
    
    backToTopButton.on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        
        // Set focus to the element with id="go-top1" after scrolling
        setTimeout(function() {
            $('#go-top1').focus();
        }, 600); // Adjust the timeout duration to match the scroll duration
    });
});





  $(function() {
    var accordionButtons = $('.toglebtn');
    var accordionButtons2 = $('.maindropcnt');
  
    function accordionToggle() {
      accordionButtons.on('click', function(e) {
        $control = $(this);
        $control2 = $(this).parent().children(".maindropcnt");
  
        accordionContent = $control.attr('aria-controls');
        checkOthers($control[0]);
  
        isAriaExp = $control.attr('aria-expanded');
        newAriaExp = (isAriaExp == "false") ? "true" : "false";
        $control.attr('aria-expanded', newAriaExp);
  
        // Add or remove 'active' class based on aria-expanded value
        $control2.toggleClass('open', newAriaExp === 'true');
  
        isAriaHid = $('#' + accordionContent).attr('aria-hidden');
        if (isAriaHid == "true") {
          $('#' + accordionContent).attr('aria-hidden', "false").css('display', 'block');
        } else {
          $('#' + accordionContent).attr('aria-hidden', "true").css('display', 'none');
        }
      });
    };
  
    function checkOthers(elem) {
      for (var i = 0; i < accordionButtons.length; i++) {
        if (accordionButtons[i] != elem) {
          if ($(accordionButtons[i]).attr('aria-expanded') == 'true') {
            $(accordionButtons[i]).attr('aria-expanded', 'false')
            $(accordionButtons2[i]).removeClass('open');
            content = $(accordionButtons[i]).attr('aria-controls');
            $('#' + content).attr('aria-hidden', 'true').css('display', 'none');
          }
        }
      }
    };
  
    // Call this function on page load
    accordionToggle();
  });
  
  // Handle focus events for VoiceOver
  $(document).on('focusin', function (event) {
    // Find the closest row to the focused element
    var closestRow = $(event.target).closest(".mainnvv");
  
    // Check if the focus is outside of elements with class "dropcnt"
    if ($(event.target).closest(".maindropcnt").length === 0) {
      // Close dropdowns only in the same row
      closestRow.find(".toglebtn").attr("aria-expanded", "false");
      closestRow.find(".maindropcnt").removeClass("open");
  
      // Add your code to hide the dropdown menu as needed here
    }
  });
  
  $(document).ready(function() {
    // Store the menu element
    var $menu = $('.maindropcnt');

    // Close the menu on Escape key press
    $(document).keydown(function(event) {
      if (event.key === 'Escape') {
        $menu.removeClass('open');
          $('.toglebtn').attr('aria-expanded', 'false');
      }
    });
});





// $(document).ready(function () {
//   setTimeout(function () {
   

//     $("img.gs__checkbox-image").attr("alt", "gift icon");

//   }, 3000);
//   }, 3000);